import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { APP_ROUTES } from '../../../app.config.vars/routes';
const CannotFinishGame = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content cannot-finish-game', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.ame_session_is_not_active'), type: 'h1' }) }), _jsx("div", { className: "modal-content-description", children: t('admin.cannot_finish_game') }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: async () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                        navigate(APP_ROUTES.rallies);
                    } }) })] }));
};
export default CannotFinishGame;
